// Rally progress is already an authoritative, clamped backend percentage. Keep
// the host display exact so a sub-threshold value can never be rounded to 100%.
export const formatRallyProgress = (progress: number) => `${progress}%`;
